import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Contact } from './types/contactTypes'

// Same page size as the people pickers: half the requests of the server's default of 10.
const PAGE_SIZE = 20

const fetchColorLabelContacts = async ({ pageParam = '1', id }: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const url = `/color-labels/${id}/contacts?page=${pageParam}&limit=${PAGE_SIZE}`
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateColorLabelContacts = (id: string) => {
  return usePaginate<Contact>('color-label-contacts', fetchColorLabelContacts, { id }, { enabled: !!id })
}
